import config from 'react-global-configuration';

config.set({
  api_url: window.env.API_URL,
  trips_url: window.env.TRIPS_URL,
  scheduler_url: window.env.SCHEDULER_URL,
  costs_url: window.env.COSTS_URL,
  dateFormat: 'YYYY-MM-DD',
  administration_url: window.env.ADMINISTRATION_URL,
  notifications_url: window.env.NOTIFICATIONS_URL
});

export default config;
